import React, { useState } from 'react';

import Diversity2Icon from '@mui/icons-material/Diversity2Outlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import { Stack } from '@mui/material';
import { useParams } from 'react-router';

import Chip from '../../components/Chip';
import ContentCard from '../../components/ContentCard';
import PageContent from '../../components/PageContent';
import { NoContentMessage } from '../../components/PageLayout';
import SkeletonStack from '../../components/SkeletonStack';
import Tabs from '../../components/Tabs';
import {
  useGetClassQuery,
} from '../../services/classes';
import { Lesson } from '../../services/classes/types';
import { getClassId, getClassName } from '../../utils/common/classes';
import useTab from '../../utils/react/hooks/useTab';

import ClassLessonDetails from './ClassLessonDetails';
import DetailsTab from './DetailsTab';
import { PageContainer } from './index.styles';
import SettingsTab from './SettingsTab';

const TAB_OPTIONS = [
  {
    key: 'details',
    label: 'Details',
    icon: <Diversity2Icon />,
  },
  {
    key: 'settings',
    label: 'Settings',
    icon: <SettingsOutlinedIcon />,
  },
];

const AdminClassPage = () => {
  const { subject, classId } = useParams();

  if (!subject || !classId) {
    return <NoContentMessage />;
  }

  const { data: classObj, isLoading: isClassLoading } = useGetClassQuery({
    subject, classId,
  });
  const [selectedLesson, setSelectedLesson] = useState<Lesson | undefined>();
  const [tab, setTab] = useTab({ default: TAB_OPTIONS[0].key });

  const deselectLesson = () => {
    setSelectedLesson(undefined);
  };

  if (isClassLoading) {
    return <SkeletonStack />;
  }

  if (!classObj) {
    return <NoContentMessage />;
  }

  return (
    <PageContent
      sideBar={selectedLesson ? (
        <ClassLessonDetails
          selectedLesson={selectedLesson}
          onClose={() => deselectLesson()}
        />
      ) : <div />}
      sideBarOpen={!!selectedLesson}
      sideBarWidth={600}
    >
      <PageContainer>
        <ContentCard
          variant="transparent"
          backButtonHref={-1}
          title={(
            <>
              Class Details (
              {getClassName(getClassId(classObj?.data.id) ?? '', classObj?.data.course ?? '')}
              )
              {classObj?.data.active ?? true ? '' : (
                <>
                  {' '}
                  <Chip
                    label="ARCHIVED"
                    variant="outlined"
                    size="small"
                  />
                </>
              )}
            </>
          )}
          titleVariant="h5"
          padding="none"
          maxWidth={720}
        >
          <Stack direction="column">
            <Tabs options={TAB_OPTIONS} selectedKey={tab} onChange={setTab} />
            {tab === 'details' && (
              <DetailsTab
                classObj={classObj.data}
                metadata={classObj.metadata}
                setSelectedLesson={setSelectedLesson}
                selectedLesson={selectedLesson}
              />
            )}
            {tab === 'settings' && (
              <SettingsTab
                classObj={classObj.data}
                metadata={classObj.metadata}
              />
            )}
          </Stack>
        </ContentCard>
      </PageContainer>
    </PageContent>
  );
};
export default AdminClassPage;
